'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

// 이 파일은 루트 레이아웃을 대체하는 별도 루트라 RootProviders 스택 바깥이다.
// 공용 러너 요청 UI(첨부·Tiptap·요청 상세 등 런타임을 요구하는 컴포넌트)를 여기에 넣지 말 것.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
